import { Component } from '@angular/core';
import { AppConfigService } from "./services/app-config.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host:
  {class:""}
})
export class AppComponent {
  title = 'birdie';
}
